step_three_handler = {

    properties: {
        title: 'Thank You!'
    },

    onLoad: function(){
        var self = this;
        $('#content-root, #map').removeClass('swipe');
        $('body').addClass('secondary-bg');
        // home_handler.updateLS();
        // home_handler.loadData();
        // $('#map').removeClass('drawStart');

        // var iconSelected = add_feature_handler.properties.selectedCategory;
        // $('.'+iconSelected).addClass('selected');
    },

    getURL: function(){
        switch(project_view_handler.properties.subtypeID) {
            case "corridors":
                url = "corridors";
                break;
            case "walking":
                url = "ped-map";
                break;
            case "transit":
                url = "transit-map";
                break;
            default:
                url = "hear";
        }
        return url;
    },

    events: function() {
        var self = this;

        self.onLoad();

        $('.next-project').click(function(event) {
            console.log("click next");
            project_view_handler.nextProject();
            return false;
        });

        $('.content-close-btn').click(function(event) {

            window.location.href = "#/project-map";
            return false;
        });

        switch (project_view_handler.properties.subtypeID) {
          case "corridors":
            $('.child-content[data-type]').hide();
            $('.child-content[data-type="corridors"]').show();
            break;
          case "pedestrian":
            $('.child-content[data-type]').hide();
            $('.child-content[data-type="pedestrian"]').show();
            break;
          default:
            $('.child-content[data-type]').hide();
            $('.child-content[data-type="bike"]').show();
            break;
        }

    }
}
